exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accordion-item:before {\n  box-shadow: none;\n}\n.slider-height {\n  height: 5px;\n}\n@media screen and (max-width: 400px) {\n.font-sm-10-px {\n    font-size: 12px;\n}\n}", ""]);

// exports
